import React from 'react';
import { FiFileText } from 'react-icons/fi';
import { Church } from '../types/church';
import AssignModalShell from '@core/components/assign/AssignModalShell';
import AssignReportTemplatesModalBody from '@features/report/template/components/AssignReportTemplatesModalBody';
import ClearAllReportTemplatesConfirmModal from '@features/report/template/components/ClearAllReportTemplatesConfirmModal';
import { useAssignReportTemplates } from '@features/report/template/hooks/useAssignReportTemplates';

type Props = {
  show: boolean;
  onHide: () => void;
  church: Church | null;
  districtId: number;
  nationId?: number;
};

const AssignReportTemplatesModal: React.FC<Props> = ({ show, onHide, church, districtId, nationId }) => {
  const assign = useAssignReportTemplates({
    show,
    scope: 'CHURCH',
    entityId: church?.church_id ?? 0,
    districtId,
    nationId,
    onHide,
  });

  return (
    <>
      <AssignModalShell
        show={show}
        onHide={assign.handleClose}
        title={
          <>
            <FiFileText aria-hidden />
            Assign Templates{church ? `: ${church.church_name}` : ''}
          </>
        }
        saving={assign.saving}
        saveDisabled={assign.saveDisabled || !assign.selectedDepartmentId}
        onSave={assign.handleSave}
        onCancel={assign.handleClose}
        testId="assign-templates-modal"
      >
        <AssignReportTemplatesModalBody {...assign} />
      </AssignModalShell>

      <ClearAllReportTemplatesConfirmModal
        show={assign.showClearAllConfirm}
        departmentName={assign.selectedDepartmentName}
        scopeLabel={assign.scopeLabel}
        saving={assign.saving}
        onConfirm={assign.confirmClearAllSave}
        onCancel={assign.dismissClearAllConfirm}
      />
    </>
  );
};

export default AssignReportTemplatesModal;
